package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.example.mystybag.appCore.logic.pages.DashboardViewModel
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.views.AppTheme

/**
 * Desktop web merchant dashboard: same data and filters as [DashboardView], without the native-only
 * overview title row (the tab bar already shows „Overview“ / „Работно табло“).
 */
@Composable
fun DashboardWebView(viewModel: DashboardViewModel) {
    val colors = AppTheme.current.colors
    UIView(
        modifier = Modifier
            .fillMaxSize()
            .background(colors.background),
        viewModel = viewModel,
        showTopBar = false,
        removeVerticalPadding = true,
        applyBottomInsetSpacer = false
    ) {
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.TopCenter
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
            ) {
                DashboardMainScreenContent(viewModel = viewModel)
            }
        }
    }
}
